import type { ColumnDef } from '@tanstack/react-table';
import { RoleBadge } from '@/auth/RoleBadge';
import { AdminNameCell } from './components/AdminNameCell';
import { StatusBadge } from './components/StatusBadge';
import type { AccountViewResponseDTO } from './types';

// Columns are driven by AccountViewResponseDTO (backend DTO), NOT the CMP User mock columns (doc 07 §4.5).
export const adminColumns: ColumnDef<AccountViewResponseDTO, unknown>[] = [
  {
    id: 'displayName',
    header: 'Name',
    cell: ({ row }) => <AdminNameCell admin={row.original} />,
  },
  {
    id: 'email',
    header: 'Email',
    accessorKey: 'email',
    cell: ({ row }) => row.original.email || '—',
  },
  {
    id: 'roles',
    header: 'Roles',
    cell: ({ row }) => {
      // Real DTO exposes `roleResponseDTOS` (RoleResponseDTO[]); render each via its `code`/`name`.
      const roles = row.original.roleResponseDTOS ?? [];
      if (roles.length === 0) return <span className="text-muted-foreground">—</span>;
      return (
        <div className="flex flex-wrap gap-1">
          {roles.map((r) => (
            <RoleBadge key={r.id ?? r.code ?? r.name} role={r.code ?? r.name ?? ''} />
          ))}
        </div>
      );
    },
  },
  {
    id: 'status',
    header: 'Status',
    // Real DTO field is `accountStatus` (NEW/ACT/TER), not `status`.
    cell: ({ row }) => <StatusBadge status={row.original.accountStatus} />,
  },
  // `createdAt` column dropped — not in real DTO. Phone number is the closest available field.
  {
    id: 'phoneNumber',
    header: 'Phone',
    cell: ({ row }) => row.original.phoneNumber || '—',
  },
];
